var __webpack_error__ = new Error();
module.exports = new Promise(function(resolve, reject) {
	if(typeof rti_control_asset_monitor !== "undefined") return resolve();
	__webpack_require__.l("https://app-rti-control-asset-monitor.p039.aws.cldsvc.net/remoteEntry.js", function(event) {
		if(typeof rti_control_asset_monitor !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "rti_control_asset_monitor");
}).then(function() { return rti_control_asset_monitor; });